import { useSession } from "@outschool/ui-auth";
import { Select } from "@outschool/ui-legacy-component-library";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";

import { PROFESSIONAL_LEARNING_MUX_VIDEO_ID } from "../../../shared/ProfessionalLearningActivities";
import { SKILLJAR_ID } from "../../../shared/SkilljarActivities";
import * as User from "../../../shared/User";
import { useSellerOrgTeachers } from "../../queries/SellerOrgQueries";

interface SectionAssignTeacherSelectProps {
  value: string;
  onChange: (newValue: string) => void;
  placeholder?: string;
  selectPlaceholderOnNull?: boolean;
}
export function hasCompletedTrainings(teacher: $TSFixMe) {
  return (
    (teacher.completed_trainings.includes(
      SKILLJAR_ID.ONLINE_TOOLS_ORG_TEACHER_ACTIVITY_ID
    ) &&
      teacher.completed_trainings.includes(
        SKILLJAR_ID.SAFETY_AND_PRIVACY_ORG_TEACHER_ACTIVITY_ID
      )) ||
    (teacher.completed_trainings.includes(
      PROFESSIONAL_LEARNING_MUX_VIDEO_ID.SAFETY_AND_PRIVACY_ACTIVITY_ID
    ) &&
      teacher.completed_trainings.includes(
        PROFESSIONAL_LEARNING_MUX_VIDEO_ID.CLASS_CONTENT_POLICIES_ACTIVITY_ID
      ))
  );
}

export default function SectionAssignTeacherSelect({
  value,
  onChange,
  selectPlaceholderOnNull,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  placeholder = null
}: SectionAssignTeacherSelectProps) {
  const { teachers } = useSellerOrgTeachers("cache-and-network");
  const { currentUser } = useSession();

  return (
    <Select
      // @ts-ignore TS(2531): Object is possibly 'null'.
      placeholder={placeholder ?? currentUser.name}
      selectPlaceholderOnNull={selectPlaceholderOnNull}
      value={value}
      options={teachers.map(teacher => ({
        value: teacher.uid,
        label: teacher.name || teacher.email,
        disabled:
          User.hasBackgroundCheckExpired(teacher) ||
          !teacher.backgroundChecked ||
          !teacher.hasVerifiedIdentity ||
          !hasCompletedTrainings(teacher)
      }))}
      onChange={onChange}
    />
  );
}
